import styled from 'styled-components';
import { breakpoints } from 'utils/rwd';

export const LookCard = styled.article`
  --look-media-width: 52.5%;

  position: relative;
  width: 100%;
  max-width: 1100px;
  min-width: 0;
  margin: 0 auto;
  overflow: hidden;
  border: 1px solid #e3e6e8;
  background: #ffffff;
`;

export const LookMediaFrame = styled.div`
  position: relative;
  width: var(--look-media-width);
  min-width: 0;
  overflow: visible;
  aspect-ratio: 4 / 5;
`;

export const PreviewImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  background: #ffffff;
  object-fit: contain;
  object-position: center;
`;

export const PreviewVideo = styled.video`
  display: block;
  width: 100%;
  height: 100%;
  background: #120e02;
  object-fit: contain;
  object-position: center;
`;

export const OriginImageFrame = styled.div`
  position: absolute;
  top: 20px;
  right: -20px;
  z-index: 2;
  width: 80px;
  height: 80px;
`;

export const OriginImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  border: 1px solid #ffffff;
  background: #ffffff;
  object-fit: contain;
`;

export const LookContent = styled.div`
  position: absolute;
  inset: 0 0 0 var(--look-media-width);
  display: flex;
  min-width: 0;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
`;

export const LookHeader = styled.header`
  display: flex;
  min-width: 0;
  padding: 20px 20px 20px 40px;
  flex: 0 0 148px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  background: #e9ecef;
`;

export const LookName = styled.div`
  display: -webkit-box;
  overflow: hidden;
  color: #120e02;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;

export const LookDescription = styled.p`
  display: -webkit-box;
  margin: 0;
  overflow: hidden;
  color: #495057;
  font-size: 13px;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
`;

export const ProductPanel = styled.div`
  display: flex;
  min-width: 0;
  min-height: 0;
  flex: 1;
  flex-direction: column;
  background: #ffffff;
`;

export const ProductList = styled.div`
  min-width: 0;
  min-height: 0;
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-color: #adb5bd transparent;
  scrollbar-width: thin;
`;

export const ProductListItem = styled.div`
  display: block;

  & + & {
    box-shadow: inset 0 1px #e3e6e8;
  }

  @container customer-preview (max-width: ${breakpoints.sm - 1}px) {
    display: ${({ $mobileVisible }) => ($mobileVisible ? 'block' : 'none')};
    height: 126px;
  }

  @container customer-preview (max-width: ${breakpoints.xs - 1}px) {
    height: 116px;
  }
`;

export const ProductPagination = styled.nav`
  display: none;
`;

export const ProductPageButton = styled.button`
  display: flex;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 1px solid #adb5bd;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  color: #212529;
  cursor: pointer;
  font-size: 18px;

  &:disabled {
    color: #adb5bd;
    cursor: not-allowed;
  }
`;

export const ItemRange = styled.span`
  color: #495057;
  font-size: 12px;
  text-align: center;
  text-transform: uppercase;
`;

export const LookProductRow = styled.div`
  display: grid;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  min-height: 126px;
  padding: 14px;
  grid-template-columns: 88px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
`;

export const LookProductImage = styled.img`
  display: block;
  width: 88px;
  aspect-ratio: 1 / 1;
  background: #ffffff;
  object-fit: contain;
`;

export const LookProductDetails = styled.div`
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 10px;
`;

export const LookProductName = styled.h3`
  display: -webkit-box;
  margin: 0;
  overflow: hidden;
  color: #212529;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;

export const VariantControls = styled.div`
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
`;

export const SizeValue = styled.span`
  display: inline-flex;
  min-width: 64px;
  max-width: 100px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid #868e96;
  align-items: center;
  color: #212529;
  font-size: 12px;
  text-transform: uppercase;
`;

export const ColorValue = styled.span`
  display: block;
  width: 22px;
  height: 22px;
  flex: 0 0 22px;
  border: 2px solid #ffffff;
  border-radius: 50%;
  background: ${({ $color }) => $color};
  box-shadow: 0 0 0 1px #ced4da;
`;

export const LookProductActions = styled.div`
  display: flex;
  min-width: 62px;
  flex-direction: column;
  align-items: flex-end;
  gap: 18px;
`;

export const BasketButton = styled.button`
  display: flex;
  width: 42px;
  height: 42px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  background: #120e02;
  color: #ffffff;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const LookProductPrice = styled.p`
  margin: 0;
  color: #212529;
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
`;

export const EmptyProducts = styled.div`
  display: flex;
  height: 100%;
  min-height: 180px;
  padding: 28px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  text-align: center;
`;

export const EmptyProductsTitle = styled.h3`
  margin: 0 0 6px;
  color: #212529;
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
`;

export const EmptyProductsText = styled.p`
  max-width: 320px;
  margin: 0;
  color: #495057;
  font-size: 13px;
`;

export const ResponsivePreview = styled.div`
  display: contents;

  @container customer-preview (max-width: ${breakpoints.sm - 1}px) {
    ${LookCard} {
      display: flex;
      flex-direction: column;
    }

    ${LookMediaFrame} {
      width: 100%;
    }

    ${OriginImageFrame} {
      top: auto;
      right: auto;
      bottom: -20px;
      left: 20px;
    }

    ${LookContent} {
      position: static;
      width: 100%;
      overflow: visible;
    }

    ${LookHeader} {
      padding: 20px;
    }

    ${ProductPanel} {
      height: 300px;
      flex: none;
    }

    ${ProductList} {
      height: 252px;
      flex: none;
      overflow: hidden;
    }

    ${ProductPagination} {
      display: grid;
      min-height: 48px;
      padding: 7px 10px;
      grid-template-columns: 36px minmax(0, 1fr) 36px;
      align-items: center;
      gap: 8px;
    }
  }

  @container customer-preview (max-width: ${breakpoints.xs - 1}px) {
    ${LookProductRow} {
      min-height: 116px;
      padding: 10px;
      grid-template-columns: 72px minmax(0, 1fr) auto;
      gap: 8px;
    }

    ${LookProductImage} {
      width: 72px;
    }

    ${ProductList} {
      height: 232px;
    }

    ${ProductPanel} {
      height: 280px;
    }

    ${SizeValue} {
      min-width: 50px;
      height: 26px;
      font-size: 10px;
    }

    ${ColorValue} {
      width: 16px;
      height: 16px;
      flex-basis: 16px;
    }

    ${BasketButton} {
      width: 34px;
      height: 34px;
    }

    ${LookProductActions} {
      min-width: 52px;
      gap: 14px;
    }
  }
`;
